import React from "react";

export default function Navbar() {
  return (
    <div>
      <nav
        className="navbar navbar-expand-lg fixed-top navbar-dark bg-dark"
        style={{ backgroundColor: "#03045e" }}
      >
        <a href="/" className="navbar-brand">
          <img
            src="image/logo.jpg"
            height="40"
            alt="Icon"
            style={{ borderRadius: "2px" }}
          />
        </a>
        <a className="navbar-brand" href="/">
          Bharat Docs Scanner
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse " id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto" color="secondary">
            <li className="nav-item active">
              <a className="nav-link" href="#main">
                Home <span className="sr-only">(current)</span>
              </a>
            </li>
            <li className="nav-item active">
              <a className="nav-link" href="#main2">
                Features
              </a>
            </li>
            <li className="nav-item active">
              <a className="nav-link" href="#download">
                Download
              </a>
            </li>
            <li className="nav-item active">
              <a className="nav-link" href="#our-team">
                Our Team
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}
